/* tslint:disable */
/* eslint-disable */
/**
 * Keyops CEP
 * Customer Engagement Platform API documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AdBoardEngagement } from '../models';
import { AdBoardEngagementDetailsDto } from '../models';
import { CreateAdBoardEngagementDto } from '../models';
import { UpdateAdBoardEngagementDto } from '../models';
/**
 * AdBoardEngagementsApi - axios parameter creator
 * @export
 */
export const AdBoardEngagementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets an AdBoardEngagement results export by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adBoardEngagementControllerAnalyseResults: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adBoardEngagementControllerAnalyseResults.');
            }
            const localVarPath = `/api/ad-board-engagements/{id}/analyse-results`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an AdBoardEngagement
         * @param {CreateAdBoardEngagementDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adBoardEngagementControllerCreate: async (body: CreateAdBoardEngagementDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling adBoardEngagementControllerCreate.');
            }
            const localVarPath = `/api/ad-board-engagements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a AdBoardEngagement by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adBoardEngagementControllerFindOne: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adBoardEngagementControllerFindOne.');
            }
            const localVarPath = `/api/ad-board-engagements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a AdBoardEngagement by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adBoardEngagementControllerGetAdBoardEngagementDetails: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adBoardEngagementControllerGetAdBoardEngagementDetails.');
            }
            const localVarPath = `/api/ad-board-engagements/{id}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refresh a AdBoardEngagement's Data by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adBoardEngagementControllerRefreshAdBoardData: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adBoardEngagementControllerRefreshAdBoardData.');
            }
            const localVarPath = `/api/ad-board-engagements/{id}/refresh`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets an AdBoardEngagement results export by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adBoardEngagementControllerResultsExport: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adBoardEngagementControllerResultsExport.');
            }
            const localVarPath = `/api/ad-board-engagements/{id}/results-export`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets an AdBoardEngagement results export by its ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adBoardEngagementControllerRunKolabAIAnalyses: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ad-board-engagements/run-kolab-ai-analyses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates an AdBoardEngagement by its ID
         * @param {UpdateAdBoardEngagementDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adBoardEngagementControllerUpdate: async (body: UpdateAdBoardEngagementDto, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling adBoardEngagementControllerUpdate.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adBoardEngagementControllerUpdate.');
            }
            const localVarPath = `/api/ad-board-engagements/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdBoardEngagementsApi - functional programming interface
 * @export
 */
export const AdBoardEngagementsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets an AdBoardEngagement results export by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adBoardEngagementControllerAnalyseResults(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await AdBoardEngagementsApiAxiosParamCreator(configuration).adBoardEngagementControllerAnalyseResults(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Create an AdBoardEngagement
         * @param {CreateAdBoardEngagementDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adBoardEngagementControllerCreate(body: CreateAdBoardEngagementDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<AdBoardEngagement>>> {
            const localVarAxiosArgs = await AdBoardEngagementsApiAxiosParamCreator(configuration).adBoardEngagementControllerCreate(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get a AdBoardEngagement by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adBoardEngagementControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<AdBoardEngagement>>> {
            const localVarAxiosArgs = await AdBoardEngagementsApiAxiosParamCreator(configuration).adBoardEngagementControllerFindOne(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get a AdBoardEngagement by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adBoardEngagementControllerGetAdBoardEngagementDetails(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<AdBoardEngagementDetailsDto>>> {
            const localVarAxiosArgs = await AdBoardEngagementsApiAxiosParamCreator(configuration).adBoardEngagementControllerGetAdBoardEngagementDetails(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Refresh a AdBoardEngagement's Data by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adBoardEngagementControllerRefreshAdBoardData(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<AdBoardEngagement>>> {
            const localVarAxiosArgs = await AdBoardEngagementsApiAxiosParamCreator(configuration).adBoardEngagementControllerRefreshAdBoardData(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Gets an AdBoardEngagement results export by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adBoardEngagementControllerResultsExport(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<Blob>>> {
            const localVarAxiosArgs = await AdBoardEngagementsApiAxiosParamCreator(configuration).adBoardEngagementControllerResultsExport(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Gets an AdBoardEngagement results export by its ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adBoardEngagementControllerRunKolabAIAnalyses(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await AdBoardEngagementsApiAxiosParamCreator(configuration).adBoardEngagementControllerRunKolabAIAnalyses(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Updates an AdBoardEngagement by its ID
         * @param {UpdateAdBoardEngagementDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adBoardEngagementControllerUpdate(body: UpdateAdBoardEngagementDto, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<AdBoardEngagement>>> {
            const localVarAxiosArgs = await AdBoardEngagementsApiAxiosParamCreator(configuration).adBoardEngagementControllerUpdate(body, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AdBoardEngagementsApi - factory interface
 * @export
 */
export const AdBoardEngagementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Gets an AdBoardEngagement results export by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adBoardEngagementControllerAnalyseResults(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return AdBoardEngagementsApiFp(configuration).adBoardEngagementControllerAnalyseResults(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an AdBoardEngagement
         * @param {CreateAdBoardEngagementDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adBoardEngagementControllerCreate(body: CreateAdBoardEngagementDto, options?: AxiosRequestConfig): Promise<AxiosResponse<AdBoardEngagement>> {
            return AdBoardEngagementsApiFp(configuration).adBoardEngagementControllerCreate(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a AdBoardEngagement by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adBoardEngagementControllerFindOne(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<AdBoardEngagement>> {
            return AdBoardEngagementsApiFp(configuration).adBoardEngagementControllerFindOne(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a AdBoardEngagement by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adBoardEngagementControllerGetAdBoardEngagementDetails(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<AdBoardEngagementDetailsDto>> {
            return AdBoardEngagementsApiFp(configuration).adBoardEngagementControllerGetAdBoardEngagementDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refresh a AdBoardEngagement's Data by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adBoardEngagementControllerRefreshAdBoardData(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<AdBoardEngagement>> {
            return AdBoardEngagementsApiFp(configuration).adBoardEngagementControllerRefreshAdBoardData(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets an AdBoardEngagement results export by its ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adBoardEngagementControllerResultsExport(id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<Blob>> {
            return AdBoardEngagementsApiFp(configuration).adBoardEngagementControllerResultsExport(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets an AdBoardEngagement results export by its ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adBoardEngagementControllerRunKolabAIAnalyses(options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return AdBoardEngagementsApiFp(configuration).adBoardEngagementControllerRunKolabAIAnalyses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates an AdBoardEngagement by its ID
         * @param {UpdateAdBoardEngagementDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adBoardEngagementControllerUpdate(body: UpdateAdBoardEngagementDto, id: string, options?: AxiosRequestConfig): Promise<AxiosResponse<AdBoardEngagement>> {
            return AdBoardEngagementsApiFp(configuration).adBoardEngagementControllerUpdate(body, id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdBoardEngagementsApi - object-oriented interface
 * @export
 * @class AdBoardEngagementsApi
 * @extends {BaseAPI}
 */
export class AdBoardEngagementsApi extends BaseAPI {
    /**
     * 
     * @summary Gets an AdBoardEngagement results export by its ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdBoardEngagementsApi
     */
    public async adBoardEngagementControllerAnalyseResults(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return AdBoardEngagementsApiFp(this.configuration).adBoardEngagementControllerAnalyseResults(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Create an AdBoardEngagement
     * @param {CreateAdBoardEngagementDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdBoardEngagementsApi
     */
    public async adBoardEngagementControllerCreate(body: CreateAdBoardEngagementDto, options?: AxiosRequestConfig) : Promise<AxiosResponse<AdBoardEngagement>> {
        return AdBoardEngagementsApiFp(this.configuration).adBoardEngagementControllerCreate(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Get a AdBoardEngagement by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdBoardEngagementsApi
     */
    public async adBoardEngagementControllerFindOne(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<AdBoardEngagement>> {
        return AdBoardEngagementsApiFp(this.configuration).adBoardEngagementControllerFindOne(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Get a AdBoardEngagement by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdBoardEngagementsApi
     */
    public async adBoardEngagementControllerGetAdBoardEngagementDetails(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<AdBoardEngagementDetailsDto>> {
        return AdBoardEngagementsApiFp(this.configuration).adBoardEngagementControllerGetAdBoardEngagementDetails(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Refresh a AdBoardEngagement's Data by id
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdBoardEngagementsApi
     */
    public async adBoardEngagementControllerRefreshAdBoardData(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<AdBoardEngagement>> {
        return AdBoardEngagementsApiFp(this.configuration).adBoardEngagementControllerRefreshAdBoardData(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Gets an AdBoardEngagement results export by its ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdBoardEngagementsApi
     */
    public async adBoardEngagementControllerResultsExport(id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<Blob>> {
        return AdBoardEngagementsApiFp(this.configuration).adBoardEngagementControllerResultsExport(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Gets an AdBoardEngagement results export by its ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdBoardEngagementsApi
     */
    public async adBoardEngagementControllerRunKolabAIAnalyses(options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return AdBoardEngagementsApiFp(this.configuration).adBoardEngagementControllerRunKolabAIAnalyses(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Updates an AdBoardEngagement by its ID
     * @param {UpdateAdBoardEngagementDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdBoardEngagementsApi
     */
    public async adBoardEngagementControllerUpdate(body: UpdateAdBoardEngagementDto, id: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<AdBoardEngagement>> {
        return AdBoardEngagementsApiFp(this.configuration).adBoardEngagementControllerUpdate(body, id, options).then((request) => request(this.axios, this.basePath));
    }
}
